import React, { forwardRef } from 'react';
import Proptypes from 'prop-types';
import Tabs from '@material-ui/core/Tabs';
import { withStyles } from '@material-ui/styles';
import Tab from '../Tab';

const StyledTabs = withStyles(theme => ({
  root: {
    borderBottom: `1px solid ${theme.palette.grey[100]}`,
    paddingLeft: theme.spacing(1.5),
    paddingRight: theme.spacing(1.5),
    overflow: 'visible',
  },
  indicator: {
    height: 2,
    borderTopRightRadius: 20,
    borderTopLeftRadius: 20,
    bottom: -1,
  },
  scroller: {
    overflow: 'visible !important',
  },
}))(Tabs);
const TabBar = forwardRef(function TabBar(
  { children, indicatorColor, className, ...restProps },
  ref
) {
  return (
    <StyledTabs
      TabIndicatorProps={{ style: { backgroundColor: indicatorColor } }}
      ref={ref}
      {...restProps}
    >
      {children}
    </StyledTabs>
  );
});

TabBar.propTypes = {
  className: Proptypes.string,
  indicatorColor: Proptypes.string,
  children: Proptypes.arrayOf(
    Proptypes.shape({
      type: Proptypes.oneOf([Tab]),
    })
  ).isRequired,
};

TabBar.defaultProps = {
  className: null,
  indicatorColor: '#454DCC',
};

TabBar.displayName = 'TabBar';

export default TabBar;
